/**
 * @generated SignedSource<<804fcf8be0a15776d4f42adb02daece2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RootNodeTitleColumn_ContentSubmissionFragment$data = {
  readonly learnOpportunity: {
    readonly root: {
      readonly structureDefinition: {
        readonly title: string;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "RootNodeTitleColumn_ContentSubmissionFragment";
};
export type RootNodeTitleColumn_ContentSubmissionFragment$key = {
  readonly " $data"?: RootNodeTitleColumn_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RootNodeTitleColumn_ContentSubmissionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RootNodeTitleColumn_ContentSubmissionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LearnOpportunityV2",
      "kind": "LinkedField",
      "name": "learnOpportunity",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LearnOpportunityV2",
          "kind": "LinkedField",
          "name": "root",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "structureDefinition",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};

(node as any).hash = "ec07fabe4542595d7e01a49e417ec1e4";

export default node;
